import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const ListaTipo = ({handleListaTipo}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miListaETipo" id="miListaETipo" onChange={handleListaTipo}>
        <option>Seleccionar...</option>
        <option>CLIENTE</option>
        <option>GENERAL</option>
      </select>
    </div>
  )
};

const ListaEstOS = ({handleListaEOS}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miListaEOS" id="miListaEOS" onChange={handleListaEOS}>
        <option>Seleccionar...</option>
        <option>ABIERTA</option>
        <option>CERRADA</option>
      </select>
    </div>
  )
};

const ListaDir = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista" id="miLista" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>CAMBIAR</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

const ListaTar = ({handleLista1}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista1" id="miLista1" onChange={handleLista1}>
        <option>Seleccionar...</option>
        <option>CAMBIAR TARIFA</option>
        <option>IGUAL TARIFA - CAMBIAR SERVICIOS</option>
        <option>IGUAL TARIFA - QUITAR UNO O VARIOS SERVICIOS</option>
        <option>IGUAL TARIFA - QUITAR TODOS LOS SERVICIOS</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

// const ListaOfe = ({handleLista2}) => {
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name="miLista2" id="miLista2" onChange={handleLista2}>
//         {/* <option>Seleccionar...</option> */}
//         {/* <option>SI</option> */}
//         <option>NO</option>
//       </select>
//     </div>
//   )
// };

const ListaEqu = ({handleLista3}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista3" id="miLista3" onChange={handleLista3}>
        <option>Seleccionar...</option>
        <option>AGREGAR - RETIRAR</option>
        <option>RETIRAR TODOS</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

const ListaClN = ({handleLista4}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista4" id="miLista4" onChange={handleLista4}>
        <option>Seleccionar...</option>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const ListaPA = ({handleListaPA}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miListaPA" id="miListaPA" onChange={handleListaPA}>
        <option>Seleccionar...</option>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const ListaPI = ({handleListaPI}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miListaPI" id="miListaPI" onChange={handleListaPI}>
        <option>Seleccionar...</option>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const ListaECr = ({handleLista5}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista5" id="miLista5" onChange={handleLista5}>
        <option>Seleccionar...</option>
        <option>CUALQUIERA</option>
        <option>NUEVO</option>
        <option>ACTIVO</option>
        <option>DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>ACTIVO, DESCONECTADO o SUSPENDIDO</option>
        <option>DESCONECTADO o SUSPENDIDO</option>
        <option>RETIRADO</option>
      </select>
    </div>
  )
};

const ListaECe = ({handleLista6}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista6" id="miLista6" onChange={handleLista6}>
        <option>Seleccionar...</option>
        <option>ACTIVO</option>
        <option>DESCONECTADO</option>
        <option>DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>ACTIVO, DESCONECTADO, SUSPENDIDO o RETIRADO</option>
        <option>DEJAR IGUAL</option>
      </select>
    </div>
  )
};

const ListaOSDA = ({handleListaOSDA}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miListaOSDA" id="miListaOSDA" onChange={handleListaOSDA}>
        <option>Seleccionar...</option>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const DetalleNivelTOS = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrTipoOS}</option>
  )
};

const ListaTOS = ({styles, handleListaTOS, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelTOS styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="miListaTOS" id="miListaTOS" onChange={handleListaTOS}>
        <option style={styles.input} value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const AddTios2 = ({styles, list, handleLista, handleListaTipo, handleListaEOS, handleLista1, handleLista3, handleLista4,
        handleListaPA, handleListaPI, handleLista5, handleLista6, handleListaOSDA, handleListaTOS, handleSubmit,
        handleChange, args, errors}) => {
  let listTOS = list
  // console.log(args)
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Tipo O de S nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Código</label>
                  <Form.Input autoComplete="off" name="codigoTipoOS" id="codigoTipoOS" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoTipoOS'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrTipoOS" id="descrTipoOS" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrTipoOS'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>OS de tipo GENERAL / CLIENTE:</label>
                  <ListaTipo styles={styles} handleListaTipo={handleListaTipo} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Al crear la OS debe quedar en estado:</label>
                  <ListaEstOS styles={styles} handleListaEOS={handleListaEOS} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Dirección ={">"} permitir:</label>
                  <ListaDir styles={styles} handleLista={handleLista} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Tarifas / Servicios ={">"} permitir:</label>
                  <ListaTar styles={styles} handleLista1={handleLista1} />
                </Form.Field>
                {/* <Form.Field>
                  <label style={styles.label}>Ofertas ={">"} permitir actualizar:</label>
                  <ListaOfe styles={styles} handleLista2={handleLista2} />
                </Form.Field> */}
                <Form.Field>
                  <label style={styles.label}>Equipos ={">"} permitir:</label>
                  <ListaEqu styles={styles} handleLista3={handleLista3} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Seleccionar para clientes nuevos:</label>
                  <ListaClN styles={styles} handleLista4={handleLista4} />
                </Form.Field>
                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Pedir Puntos Adicionales:</label>
                        <ListaPA styles={styles} handleListaPA={handleListaPA} />
                      </div>
                      <div className="column" style={{width: '50%'}}>
                      <label style={styles.label}>Permitir imprimir las OS:</label>
                        <ListaPI styles={styles} handleListaPI={handleListaPI} />
                      </div>
                    </div>
                  </div>
                </Form.Field>
                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Estado del cliente al crear OS:</label>
                        <ListaECr styles={styles} handleLista5={handleLista5} />
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Estado del cliente al cerrar OS:</label>
                        <ListaECe styles={styles} handleLista6={handleLista6} />
                      </div>
                    </div>
                  </div>
                </Form.Field>

                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Si cambia de dirección generar OS a dirección anterior:</label>
                        <ListaOSDA styles={styles} handleListaOSDA={handleListaOSDA} />
                      </div>
                      {args.genOSDirAnt==="SI" &&
                        <div className="column" style={{width: '50%'}}>
                          <label style={styles.label}>Tipo de OS a generar:</label>
                          <ListaTOS styles={styles} list={listTOS} handleListaTOS={handleListaTOS} />
                        </div>
                      }
                    </div>
                  </div>
                </Form.Field>

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddTios2
